import axiosInstance from "./axiosInstance";

export const query = async (url) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => ({
        status: response.status,
        headers: response.headers,
        data: response.data.data,
        total: response.data.total,
        message: response.data.message,
      }))
      .then(({ status, headers, data, total, message }) => {
        if (!!total || total === 0) total = parseInt(total, 10);
        if (status < 200 || status >= 300) {
          return reject("error occurred");
        }
        return resolve({ status, headers, data, total, message });
      })
      .catch((err) => {
        if (!!err.response && !!err.response.data && err.response.data.message)
          return reject(err.response.data.message);
        return reject(err.message);
      });
  });
};

export const queryList = async (source, params) => {
  // construct URL to query
  const url = `/${source}?${params}`;

  return query(url);
};

export const getOne = async (source, id) => {
  // construct URL to query
  const url = `/${source}/${id}`;

  return query(url);
};

export const create = async (source, data, overwriteUrl) => {
  let url = `/${source}/0`;
  if (!!overwriteUrl) url = overwriteUrl;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => ({
        status: response.status,
        headers: response.headers,
        data: response.data.data,
      }))
      .then(({ status, headers, data }) => {
        if (status < 200 || status >= 300) {
          return reject("error occurred");
        }
        return resolve({ status, headers, data });
      })
      .catch((err) => {
        if (!!err.response && !!err.response.data && err.response.data.message)
          return reject(err.response.data.message);
        return reject(err.message);
      });
  });
};

export const post = async (source, data) => {
  const url = `/${source}`;
  return create("", data, url);
};

export const update = async (source, data) => {
  const url = `/${source}/${data.id}?method=PUT`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => ({
        status: response.status,
        headers: response.headers,
        data: response.data.data,
      }))
      .then(({ status, headers, data }) => {
        if (status < 200 || status >= 300) {
          return reject("error occurred");
        }
        return resolve({ status, headers, data });
      })
      .catch((err) => {
        if (!!err.response && !!err.response.data && err.response.data.message)
          return reject(err.response.data.message);
        return reject(err.message);
      });
  });
};

export const upload = async (directoryName, file) => {
  let bodyFormData = new FormData();
  bodyFormData.append("directory", directoryName);
  bodyFormData.append("myFile", file);
  const url = `/upload`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, bodyFormData, {
        headers: {
          "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
        },
      })
      .then((response) => ({
        status: response.status,
        headers: response.headers,
        data: response.data.data,
      }))
      .then(({ status, headers, data }) => {
        if (status < 200 || status >= 300) {
          return reject("error occurred");
        }
        return resolve({ status, headers, data });
      })
      .catch((err) => {
        if (!!err.response && !!err.response.data && err.response.data.message)
          return reject(err.response.data.message);
        return reject(err.message);
      });
  });
};
